// vant 2.12.27 未自带 ru-RU 语言包，此包按 vant/lib/locale/lang/zh-CN.js 的完整 key 树补齐
export default {
  name: 'Имя',
  tel: 'Телефон',
  save: 'Сохранить',
  confirm: 'Подтвердить',
  cancel: 'Отмена',
  delete: 'Удалить',
  complete: 'Готово',
  loading: 'Загрузка...',
  telEmpty: 'Укажите телефон',
  nameEmpty: 'Укажите имя',
  nameInvalid: 'Некорректное имя',
  confirmDelete: 'Вы действительно хотите удалить?',
  telInvalid: 'Некорректный номер телефона',
  vanCalendar: {
    end: 'Конец',
    start: 'Начало',
    title: 'Выбор даты',
    confirm: 'ОК',
    startEnd: 'Начало/Конец',
    weekdays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthTitle: function monthTitle(year, month) {
      return month + '/' + year
    },
    rangePrompt: function rangePrompt(maxRange) {
      return 'Можно выбрать не более ' + maxRange + ' дней'
    }
  },
  vanCascader: {
    select: 'Выберите'
  },
  vanContactCard: {
    addText: 'Добавить контакт'
  },
  vanContactList: {
    addText: 'Новый контакт'
  },
  vanPagination: {
    prev: 'Назад',
    next: 'Вперед'
  },
  vanPullRefresh: {
    pulling: 'Потяните вниз для обновления...',
    loosing: 'Отпустите для обновления...'
  },
  vanSubmitBar: {
    label: 'Итого:'
  },
  vanCoupon: {
    unlimited: 'Без ограничений',
    discount: function discount(_discount) {
      return 'Скидка ' + (100 - _discount * 10) + '%'
    },
    condition: function condition(_condition) {
      return 'От ' + _condition
    }
  },
  vanCouponCell: {
    title: 'Купон',
    tips: 'Нет доступных купонов',
    count: function count(_count) {
      return 'Доступно купонов: ' + _count
    }
  },
  vanCouponList: {
    empty: 'Нет купонов',
    exchange: 'Обменять',
    close: 'Не использовать купон',
    enable: 'Доступен',
    disabled: 'Недоступен',
    placeholder: 'Введите код купона'
  },
  vanAddressEdit: {
    area: 'Регион',
    postal: 'Индекс',
    areaEmpty: 'Выберите регион',
    addressEmpty: 'Укажите адрес',
    postalEmpty: 'Неверный индекс',
    defaultAddress: 'Сделать адресом по умолчанию',
    telPlaceholder: 'Телефон получателя',
    namePlaceholder: 'Имя получателя',
    areaPlaceholder: 'Регион'
  },
  vanAddressEditDetail: {
    label: 'Адрес',
    placeholder: 'Улица, дом, квартира и т.д.'
  },
  vanAddressList: {
    add: 'Добавить адрес'
  }
}
